var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElTableColumn',_vm._g(_vm._b({attrs:{"resizable":false,"min-width":150}},'ElTableColumn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }